'use client'

import { UserData } from '@/app/lib/definitions'
import { Select, SelectItem } from '@nextui-org/select'
import { Spinner } from '@nextui-org/spinner'
import { useEffect, useState } from 'react'

export default function AssociationIdChanger({
    user,
}: Readonly<{ user: UserData }>) {
    const [associations, setAssociations] = useState<
        [{ id: string; name: string }] | null
    >(null)

    useEffect(() => {
        fetch('/api/getAllAssociationIndex').then(async (res) => {
            const assoc = (await res.json()) as [{ id: string; name: string }]
            setAssociations(assoc)
        })
    }, [])

    function handleChange(id: string) {
        fetch('/api/editUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                uid: user.uid,
                email: user.email,
                name: user.name,
                type: user.type,
                telephoneNumber: user.telephoneNumber,
                events: user.events,
                associationId: id,
            }),
        }).then(() => {
            window.location.reload()
        })
    }

    return (
        <>
            {associations === null && <Spinner color="primary" />}
            {associations != null && user.type === 'admin' && (
                <Select
                    items={associations}
                    aria-label="Associazione"
                    size="lg"
                    placeholder="Cambia associazione"
                    className="w-full justify-self-center md:w-2/3 lg:w-2/3"
                    disallowEmptySelection={true}
                    onChange={(e) => {
                        handleChange(e.target.value)
                    }}
                    classNames={{
                        base: 'border-2 border-black rounded-none',
                        trigger: 'bg-white rounded-none',
                        listbox: 'overflow-y-auto max-h-40',
                    }}
                >
                    {(entry) => (
                        <SelectItem key={entry.id}>{entry.name}</SelectItem>
                    )}
                </Select>
            )}
        </>
    )
}
